import type { LabelHTMLAttributes } from 'react';

import { cn } from '@/utils/cn';

type Props = {
  className?: string;
} & LabelHTMLAttributes<HTMLLabelElement>;

const Label = ({ className = '', children, ...rest }: Props) => {
  return (
    <label
      className={cn('block text-sm leading-6 font-semibold text-gray-900', className)}
      {...rest}
    >
      {children}
    </label>
  );
};

export default Label;
